import { useTranslation } from '@/lib/i18n';
import type { RefObject } from 'react';

export function TermsAndConditionsDialog(props: {
	ref: RefObject<HTMLTableElement | null> | undefined;
	responsible: string;
	purpose: string;
	legitimacy: string;
	recipients: string;
	rights: string;
	additionalInfo: string;
}) {
	const { i18n } = useTranslation();

	return (
		<table ref={props.ref}>
			<tbody>
				<tr>
					<td className="font-semibold">{i18n.termsAndConditions.responsible.title}</td>
					<td>{props.responsible}</td>
				</tr>
				<tr>
					<td className="font-semibold">{i18n.termsAndConditions.purpose.title}</td>
					<td>{props.purpose}</td>
				</tr>
				<tr>
					<td className="font-semibold">{i18n.termsAndConditions.legitimacy.title}</td>
					<td>{props.legitimacy}</td>
				</tr>
				<tr>
					<td className="font-semibold">{i18n.termsAndConditions.recipients.title}</td>
					<td>{props.recipients}</td>
				</tr>
				<tr>
					<td className="font-semibold">{i18n.termsAndConditions.rights.title}</td>
					<td>{props.rights}</td>
				</tr>
				<tr>
					<td className="font-semibold">{i18n.termsAndConditions.additionalInfo.title}</td>
					<td style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: props.additionalInfo }} />
				</tr>
			</tbody>
		</table>
	);
}
